export const ESCROW_ACCOUNT_ERROR = 'ESCROW_ACCOUNT_ERROR';
export const ESCROW_ACCOUNT_LOADING = 'ESCROW_ACCOUNT_LOADING';

export const ESCROW_ACCOUNT_LOADING_IN_MODAL = 'ESCROW_ACCOUNT_LOADING_IN_MODAL';

export const SAVE_AGREEMENT_DETAILS = 'SAVE_AGREEMENT_DETAILS';
export const SAVE_AGREEMENT_DETAILS_SUCCESS = 'SAVE_AGREEMENT_DETAILS_SUCCESS';
export const SAVE_AGREEMENT_DETAILS_ERROR = 'SAVE_AGREEMENT_DETAILS_ERROR';

export const FETCH_ACCOUNT_TRUSTEE = 'FETCH_ACCOUNT_TRUSTEE';
export const FETCH_ACCOUNT_TRUSTEE_SUCCESS = 'FETCH_ACCOUNT_TRUSTEE_SUCCESS';
export const FETCH_ACCOUNT_TRUSTEE_ERROR = 'FETCH_ACCOUNT_TRUSTEE_ERROR';

export const FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL = 'FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL';
export const FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL_SUCCESS = 'FETCH_APPLICATION_ESCROW_ACCOUNT_DETAIL_SUCCESS';

export const CLEAR_ESCROW_ACCOUNT_APPLICATION_ERROR = 'CLEAR_ESCROW_ACCOUNT_APPLICATION_ERROR';

export const UPDATE_AGREEMENT_DETAILS_DATA = 'UPDATE_AGREEMENT_DETAILS_DATA';

export const UPDATE_SPECIAL_CONDITION_DATA = 'UPDATE_SPECIAL_CONDITION_DATA';

export const FETCH_SPECIAL_CONDITION_SUCCESS = 'FETCH_SPECIAL_CONDITION_SUCCESS';

export const ADD_SPECIAL_CONDITION = 'ADD_SPECIAL_CONDITION';
export const ADD_SPECIAL_CONDITION_SUCCESS = 'ADD_SPECIAL_CONDITION_SUCCESS';
export const ADD_SPECIAL_CONDITION_ERROR = 'ADD_SPECIAL_CONDITION_ERROR';

export const REMOVE_SPECIAL_CONDITION = 'REMOVE_SPECIAL_CONDITION';
export const REMOVE_SPECIAL_CONDITION_SUCCESS = 'REMOVE_SPECIAL_CONDITION_SUCCESS';
export const REMOVE_SPECIAL_CONDITION_ERROR = 'REMOVE_SPECIAL_CONDITION_ERROR';

export const EDIT_SPECIAL_CONDITION = 'EDIT_SPECIAL_CONDITION';
export const EDIT_SPECIAL_CONDITION_SUCCESS = 'EDIT_SPECIAL_CONDITION_SUCCESS';
export const EDIT_SPECIAL_CONDITION_ERROR = 'EDIT_SPECIAL_CONDITION_ERROR';

export const ADD_ADMINSTRATION_FEES_SCHEDULE = 'ADD_ADMINSTRATION_FEES_SCHEDULE';
export const ADD_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'ADD_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';
export const ADD_ADMINSTRATION_FEES_SCHEDULE_ERROR = 'ADD_ADMINSTRATION_FEES_SCHEDULE_ERROR';

export const EDIT_ADMINSTRATION_FEES_SCHEDULE = 'EDIT_ADMINSTRATION_FEES_SCHEDULE';
export const EDIT_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'EDIT_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';
export const EDIT_ADMINSTRATION_FEES_SCHEDULE_ERROR = 'EDIT_ADMINSTRATION_FEES_SCHEDULE_ERROR';

export const REMOVE_ADMINSTRATION_FEES_SCHEDULE = 'REMOVE_ADMINSTRATION_FEES_SCHEDULE';
export const REMOVE_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'REMOVE_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';
export const REMOVE_ADMINSTRATION_FEES_SCHEDULE_ERROR = 'REMOVE_ADMINSTRATION_FEES_SCHEDULE_ERROR';

export const UPDATE_ADMINSTRATION_FEES_SCHEDULE_DATA = 'UPDATE_ADMINSTRATION_FEES_SCHEDULE_DATA';
export const FETCH_ADMINSTRATION_FEES_SCHEDULE_SUCCESS = 'FETCH_ADMINSTRATION_FEES_SCHEDULE_SUCCESS';

export const DEVELOPER_APPROVAL = 'DEVELOPER_APPROVAL';
export const DEVELOPER_APPROVAL_SUCCESS = 'DEVELOPER_APPROVAL_SUCCESS';
export const DEVELOPER_APPROVAL_ERROR = 'DEVELOPER_APPROVAL_ERROR';

export const BANK_CHECKER_APPROVAL = 'BANK_CHECKER_APPROVAL';
export const BANK_CHECKER_APPROVAL_SUCCESS = 'BANK_CHECKER_APPROVAL_SUCCESS';
export const BANK_CHECKER_APPROVAL_ERROR = 'BANK_CHECKER_APPROVAL_ERROR';

export const BANK_SIGNATORY_APPROVAL = 'BANK_SIGNATORY_APPROVAL';
export const BANK_SIGNATORY_APPROVAL_SUCCESS = 'BANK_SIGNATORY_APPROVAL_SUCCESS';
export const BANK_SIGNATORY_APPROVAL_ERROR = 'BANK_SIGNATORY_APPROVAL_ERROR';

export const DEVELOPER__SIGNATORY_APPROVAL = 'DEVELOPER__SIGNATORY_APPROVAL';
export const DEVELOPER__SIGNATORY_APPROVAL_SUCCESS = 'DEVELOPER__SIGNATORY_APPROVAL_SUCCESS';
export const DEVELOPER__SIGNATORY_APPROVAL_ERROR = 'DEVELOPER__SIGNATORY_APPROVAL_ERROR';

export const REJECT_WITH_REASON = 'REJECT_WITH_REASON';
export const REJECT_WITH_REASON_SUCCESS = 'REJECT_WITH_REASON_SUCCESS';
export const REJECT_WITH_REASON_ERROR = 'REJECT_WITH_REASON_ERROR';

export const UPDATE_ACCOUNT_DETAILS = 'UPDATE_ACCOUNT_DETAILS';
export const INITIATE_ESCROW_ACCOUNT_APPLICATION = 'INITIATE_ESCROW_ACCOUNT_APPLICATION';
export const INITIATE_ESCROW_ACCOUNT_APPLICATION_SUCCESS = 'INITIATE_ESCROW_ACCOUNT_APPLICATION_SUCCESS';
export const ESCROW_ACCOUNT_LOADING_SUCCESS = 'ESCROW_ACCOUNT_LOADING_SUCCESS';
export const FETCH_APPLICATION_ESCROW_ACCOUNT_SUCCESS = 'FETCH_APPLICATION_ESCROW_ACCOUNT_SUCCESS';

export const ESCROW_ACCOUNT_PAYMENT_BREAKDOWN = 'ESCROW_ACCOUNT_PAYMENT_BREAKDOWN';
export const ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_ERROR = 'ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_ERROR';
export const ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_SUCCESS = 'ESCROW_ACCOUNT_PAYMENT_BREAKDOWN_SUCCESS';

export const DOWNLOAD_DOCUMENT_ESCROW = 'DOWNLOAD_DOCUMENT_ESCROW';
export const DOWNLOAD_DOCUMENT_ESCROW_SUCCESS = 'DOWNLOAD_DOCUMENT_ESCROW_SUCCESS';
export const DOWNLOAD_DOCUMENT_ESCROW_ERROR = 'DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_ERROR';

export const RESET_ESCROW_ACCOUNT_ERROR = 'RESET_ESCROW_ACCOUNT_ERROR';

// New Service

export const CHANGE_ESCROW_STEP = 'CHANGE_ESCROW_STEP';
export const UPDATE_SERVICE_STATE = 'UPDATE_SERVICE_STATE';
export const SERVICE_LOADING = 'SERVICE_LOADING';
export const SERVICE_ERROR = 'SERVICE_ERROR';
export const SERVICE_SUCCESS = 'SERVICE_SUCCESS';
export const CLEAR_SERVICE_ERROR = 'CLEAR_SERVICE_ERROR';
export const SERVICE_FORM_ERROR = 'SERVICE_FORM_ERROR';

export const CLEAR_SERVICE_APPLICATION = 'CLEAR_SERVICE_APPLICATION';

export const FETCH_APPLICATION_ESCROW_SERVICE_PROVIDER_SUCCESS = 'FETCH_APPLICATION_ESCROW_SERVICE_PROVIDER_SUCCESS';
export const FETCH_APPLICATION_ESCROW_SERVICE_DISBURSEMENTS_LIST_SUCCESS =
  'FETCH_APPLICATION_ESCROW_SERVICE_DISBURSEMENTS_LIST_SUCCESS';
export const SET_SELECTED_COMPANY_ID = 'SET_SELECTED_COMPANY_ID';
export const FETCH_INSPECTION_COMPANY_LIST_SUCCESS = 'FETCH_INSPECTION_COMPANY_LIST_SUCCESS';
export const ADD_INSPECTION_COMPANY_SUCCESS = 'ADD_INSPECTION_COMPANY_SUCCESS';
export const REMOVE_INSPECTION_COMPANY_SUCCESS = 'REMOVE_INSPECTION_COMPANY_SUCCESS';
export const SERVICE_DOCUMENTS_SUCCESS = 'SERVICE_DOCUMENTS_SUCCESS';
export const UPDATE_COMPANY_SEARCH = 'UPDATE_COMPANY_SEARCH';
export const UPDATE_PAYMENT_DETAILS = 'UPDATE_PAYMENT_DETAILS';
export const UPDATE_PROVIDER_DETAILS = 'UPDATE_PROVIDER_DETAILS';
export const PROGRESS_DETAILS_FIELD_CHANGE = 'PROGRESS_DETAILS_FIELD_CHANGE';
export const ESCROW_ACCOUNT_DETAILS_DETAILS_FIELD_CHANGE = 'ESCROW_ACCOUNT_DETAILS_DETAILS_FIELD_CHANGE';
export const SAVE_PROGRESS_DETAILS = 'SAVE_PROGRESS_DETAILS';
export const APPROVAL_SUCCESS = 'APPROVAL_SUCCESS';
export const RESET_APPLICATION = 'RESET_APPLICATION';
